const colors = {
  '@global': {
    ':root': {
      '&, &.light': {
        '--x-accent-1-1': '#C209C1',
        '--x-accent-1-2': '#CE3ACD',
        '--x-accent-1-3': '#DA6BDA',
        '--x-accent-1-4': '#E79DE6',
        '--x-accent-1-5': '#F6E8F1',
        '--x-accent-1-action': '#8F008A',
        '--x-accent-1-6': '#FAEAFA',

        '--x-accent-2-1': '#5A00EE',
        '--x-accent-2-2': '#7B33F1',
        '--x-accent-2-3': '#9C66F5',
        '--x-accent-2-4': '#BD99F8',
        '--x-accent-2-5': '#DACAFB',
        '--x-accent-2-6': '#3D00A2',
        '--x-accent-2-action': '#3A0098',

        '--x-status-success': '#007675',
        '--x-status-success-action': 'green',
        '--x-status-error': '#E7000A',
        '--x-status-error-action': 'red',
        '--x-status-warning': '#F67E0C',
        '--x-status-warning-action': 'yellow',
        '--x-status-info': '#11a8ee',
        '--x-status-info-action': 'blue',

        '--x-border-1': '#e7e7e7',
        '--x-border-2': '#cccccc',
        '--x-border-3': '#f2f2f7',
        '--x-border-4': '#b7b7b7',
        '--x-border-5': '#C9C9C9',
        '--x-border-filetype': '#007675',

        '--x-bg-1': '#ffffff',
        '--x-bg-2': '#f2f2f7',
        '--x-bg-3': '#e5e5e5',
        '--x-bg-4': '#262628',
        '--x-bg-5': '#F7F7F7',
        '--x-bg-6': '#F0F0F0',
        '--x-bg-7': '#EDEDED',
        '--x-bg-8': '#E3E3E3',
        '--x-bg-9': '#D9D9D9',
        '--x-bg-10': '#158380',
        '--x-bg-11': '#F7D4F7',
        '--x-bg-12': '#FCFCFC',
        '--x-bg-13': '#ECECEC',
        '--x-bg-14': '#f2f2f2',
        '--x-bg-15': '#E7DCF9',

        '--x-bg-accent': 'rgba(76, 4, 76, 0.1)',
        '--x-bg-filetype': '#C0381D',
        '--x-bg-modal': 'rgba(0,0,0,.75)',
        '--x-bg-section-card': '#F4F5F8',

        '--x-bg-section-card-opacity': 'rgba(244,245,248,0.5)',

        '--x-shadow-1': '#cccccc',
        '--x-shadow-filetype': '#00767554',
        '--x-shadow-card': 'rgba(17, 18, 54, 0.16)',

        '--x-text-color-1': '#080808',
        '--x-text-color-2': '#5F5F5F',
        '--x-text-color-3': '#f9f9f9',
        '--x-text-color-4': '#808080',
        '--x-text-color-5': '#222222',
        '--x-text-color-6': '#999999',
        '--x-text-color-7': '#303030',
        '--x-text-color-8': '#b4b4b4',
        '--x-text-color-disabled': '#9D9D9D',
        '--x-text-color-disabled-1': '#CFCFCF',

        '--x-textf-field-color-1': '#949494',

        '--x-icon-color-1': 'var(--x-text-color-1)',
        '--x-icon-color-2': 'var(--x-text-color-2)',
        '--x-icon-color-3': 'var(--x-text-color-3)',

        '--x-black': 'var(--x-text-color-1)',
        '--x-black-1': '#000000',
        '--x-white': 'var(--x-text-color-3)',

        '--x-alert-description-color': '#888888',

        '--x-footer-bg': '#1E2129',

        '--x-new-label-color': '#FE9D24',
        '--x-error-color': '#D31E2A',

        '--x-bg-app-icon-red': 'rgba(211, 30, 42, 0.2)',
        '--x-bg-app-icon-green': '#D8E8E6',
        '--x-bg-app-icon-light-green': 'rgba(69, 164, 85, 0.2)',
        '--x-bg-app-icon-yellow': '#FCECD2',
        '--x-bg-app-icon-blue': '#DAE9F8',
        '--x-bg-app-icon-purple': '#F2EBFE',
        '--x-bg-app-icon-pink': '#FCEEFC',
        '--x-bg-app-icon-magenta': 'rgba(194, 9, 193, 0.2)',
        '--x-bg-app-icon-purple-dark': 'rgba(90, 0, 238, 0.2)',
        '--x-bg-app-icon-pink-dark': 'rgba(116, 5, 116, 0.2)',
        '--x-bg-app-icon-turquoise': 'rgba(16, 147, 127, 0.2)',
      },

      '&.dark': {
        '--x-accent-1-1': '#72FFEA',
        '--x-accent-1-2': '#00C5C3',
        '--x-accent-1-3': '#009E9C',
        '--x-accent-1-4': '#007675',
        '--x-accent-1-5': '#004F4E',
        '--x-accent-1-action': '#00C5C3',

        '--x-accent-2-1': '#7B33F1',
        '--x-accent-2-2': '#5300DB',
        '--x-accent-2-3': '#4400B5',
        '--x-accent-2-4': '#3D00A2',
        '--x-accent-2-5': '#2F007C',
        '--x-accent-2-action': '#4400B5',

        '--x-status-success': '#72FFEA',
        '--x-status-success-action': 'green',
        '--x-status-error': '#F33462',
        '--x-status-error-action': 'red',
        '--x-status-warning': '#E4A546',
        '--x-status-warning-action': 'yellow',
        '--x-status-info': '#11a8ee',
        '--x-status-info-action': 'blue',

        '--x-border-1': '#181818',
        '--x-border-2': '#333333',
        '--x-border-3': '#0d0d08',
        '--x-border-4': '#0d0d08',
        '--x-border-filetype': '#007675',

        '--x-bg-1': '#000000',
        '--x-bg-2': '#0d0d08',
        '--x-bg-3': '#1a1a1a',
        '--x-bg-4': '#d9d9d7',
        '--x-bg-filetype': '#C0381D',
        '--x-bg-modal': 'rgba(0,0,0,.35)',
        '--x-bg-section-card': '#0B0A07',

        '--x-shadow-1': '#333333',
        '--x-shadow-filetype': '#00767554',
        '--x-shadow-card': 'rgba(17, 18, 54, 0.16)',

        '--x-text-color-1': '#f9f9f9',
        '--x-text-color-2': '#A0A0A3',
        '--x-text-color-3': '#080808',
        '--x-text-color-disabled': '#636369',

        '--x-icon-color-1': 'var(--x-text-color-1)',
        '--x-icon-color-2': 'var(--x-text-color-2)',
        '--x-icon-color-3': 'var(--x-text-color-3)',

        '--x-black': 'var(--x-text-color-1)',
        '--x-white': 'var(--x-text-color-3)',
      },

      '--x-text-color-4': '#222',
      '--x-aim-outline-color': '#005fcc',

      '--x-disabled-rate': 0.48,

      '--x-breadcrumb-normal': '#808080',
      '--x-breadcrumb-last': '#4C4C4C',

      '--x-transparent-dark': 'rgba(18, 18, 18, 0.72)',
      '--x-transparent-light': 'rgba(255, 255, 255, 0.72)',
      '--x-transparent-linear-down':
        'linear-gradient(180deg, rgba(18, 18, 18, 0.6336) 0%, rgba(18, 18, 18, 0) 100%)',
      '--x-transparent-linear-up':
        'linear-gradient(360deg, rgba(18, 18, 18, 0.6336) 0%, rgba(18, 18, 18, 0) 100%)',

      '--x-gradient-primary':
        'linear-gradient(141.45deg, #00FFED 0%, #19D7E7 22.97%, #7F4AD9 45.71%, #AF1FC6 66.78%, #D402C0 100%)',
      '--x-gradient-dusk': 'linear-gradient(165.96deg, #5299BE 0%, #E54A39 51.56%, #376C34 100%)',
      '--x-gradient-desert': 'linear-gradient(166.24deg, #CB8160 0%, #323539 100%)',
      '--x-gradient-sunrise':
        'linear-gradient(165.96deg, #E9B77F 0%, #E51E2B 55.73%, #352CB6 100%)',
      '--x-gradient-sandy-storm': 'linear-gradient(166.19deg, #FFB3B3 0%, #2D5A6B 100%)',
      '--x-gradient-gold': 'linear-gradient(164.31deg, #F3A53A 0%, #BF5794 52.31%, #A0258F 100%)',
      '--x-gradient-venus': 'linear-gradient(166.19deg, #FFADFF 0%, #379087 50.7%, #BD382A 100%)',
      '--x-gradient-sahara': 'linear-gradient(166.19deg, #FFFF6F 0%, #84403D 50.7%, #553D36 100%)',
      '--x-gradient-alien': 'linear-gradient(166.19deg, #56BAC0 0%, #CD7861 50.7%, #5C22C3 100%)',
      '--x-gradient-midnight':
        'linear-gradient(166.19deg, #FFB4B4 0%, #5C2550 50.7%, #285D74 100%)',

      '--x-icon-bg-yellow': '#FCECD2',
      '--x-icon-bg-red': 'rgba(211, 30, 42, 0.2)',
      '--x-icon-bg-magenta': 'rgba(194, 9, 193, 0.2)',
      '--x-icon-bg-purple': 'rgba(90, 0, 238, 0.2)',
      '--x-icon-bg-indigo': 'rgba(116, 5, 116, 0.2)',
      '--x-icon-bg-light-green': 'rgba(69, 164, 85, 0.2)',
      '--x-icon-bg-green': 'rgba(16, 147, 127, 0.2)',
      '--x-icon-bg-pink': '#FCEEFC',
      '--x-icon-bg-blue': '#dae8f9',

      '--x-icon-fill-yellow': '#F19E1F',
      '--x-icon-fill-red': '#E34C3C',
      '--x-icon-fill-magenta': 'var(--x-accent-1-1)',
      '--x-icon-fill-purple': 'var(--x-accent-2-1)',
      '--x-icon-fill-indigo': '#740574',
      '--x-icon-fill-blue': '#4492DC',
      '--x-icon-fill-light-green': '#45A456',
      '--x-icon-fill-green': '#3D8D84',
      '--x-icon-fill-pink': 'var(--x-accent-1-1)',
    },
  },
};

export default colors;
